module.exports = "/_next/static/images/OptimizedForCost@2x-6b8d256c4e5ba5a6f7ecb7bf51ccfde3.png";